import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Rating,
  Stack,
} from "@mui/material";
import { useTranslation } from "../../../../hooks/useTranslation";
import { ProductDetail } from "../types";
import { Section } from "./Section";

type SellerProps = {
  productDetail?: ProductDetail;
};
export const Seller = ({ productDetail }: SellerProps) => {
  const { translate, translateWithoutPrefix } = useTranslation("pages.product");

  return (
    <Section title={translate("seller")}>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>{translate("amazonSeller")}</TableCell>
            <TableCell>
              {productDetail?.supplier?.supplierName ??
                translateWithoutPrefix("common.unknown")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("sellerType")}</TableCell>
            <TableCell>
              {productDetail?.supplier?.supplierId === "Amazon"
                ? "SBA"
                : productDetail?.supplier?.shipsFromAmazon
                  ? "FBA"
                  : translateWithoutPrefix("common.unknown")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("sellerCountry")}</TableCell>
            <TableCell>{translateWithoutPrefix("common.USA")}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("amazonRating")}</TableCell>
            <TableCell>
              <Stack direction={"row"}>
                <Rating
                  name="read-only"
                  value={
                    productDetail?.marketplaceProduct?.product?.averageRating
                  }
                  precision={0.5}
                  readOnly
                  size="small"
                />
                <Box sx={{ ml: 1 }}>
                  {productDetail?.marketplaceProduct?.product?.averageRating ??
                    translateWithoutPrefix("common.unknown")}
                </Box>
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Section>
  );
};
